import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { AuthService } from '../services';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
  constructor(
    private auth: AuthService,
    private router: Router
  ) {}

  canActivate(): Observable<boolean> | boolean {
    if (!this.auth.hasValidSession()) {
      void this.router.navigate(['/login']);
      return false;
    }

    if (this.auth.isSessionValidated()) {
      if (!this.auth.isSessionValid()) {
        void this.router.navigate(['/login']);
        return false;
      }
      return true;
    }

    return this.auth.validateSession().pipe(
      take(1),
      map((valid) => {
        if (!valid) {
          void this.router.navigate(['/login']);
        }
        return valid;
      })
    );
  }
}
